import { Link } from "react-router-dom";
import React from 'react';
import {Skeleton} from "@mui/material";
import {empty_bk, FormatNumberByhkh} from "../clientconfigwebapp";
import LazyLoad from 'react-lazy-load';
const PackageCard = (props) => {


    let link_post_get="/" + props.link_to;
    link_post_get=link_post_get.replaceAll("//","")

    return (
        <>



            {
                String(props.type_card)=="skeleton" ?  (

                <>
                    <Skeleton variant="rounded" width="100%" height={"60px"}  style={{marginTop: "5px"}} />
                </>

            ) : (
                <>
                    <a  className="flexRowStartStart package-card-container" href={link_post_get}>
                        <LazyLoad threshold={0.95}>
                            <img src={props.img_src} alt={props.title} />
                        </LazyLoad>
                            <div className="flexColStartStart package-card-info">
                                <h3 className="contentdotline contentdotline-2">{props.title}</h3>
                                <p className="contentdotline contentdotline-3">
                                    {props.summery_text}
                                </p>
                                <div className="flexRowBetCenter package-card-footer">
                                    <span style={{'display': empty_bk(props.price_line) || String(props.price_line)=="0" ? ('none') : ('inline-block') }}>{props.price_line_text}{ FormatNumberByhkh(props.price_line,".",",")} تومان</span>
                                    <span style={{"fontFamily":"'iran'"}}>{ FormatNumberByhkh( props.price,".",",")} تومان</span>
                                </div>
                            </div>
                            <span  className="flexColCenterCenter more-btn"></span>
                            </a>


                </>

            ) }

        </>
    );

}
export default PackageCard;

